export default function calculateVideoBitrate(fileSizeBytes, durationSeconds) {
  // Convert fileSizeBytes to bits (1 byte = 8 bits)
  const fileSizeBits = fileSizeBytes * 8;

  // Calculate bitrate in bits per second (bps)
  const bitrateBps = fileSizeBits / durationSeconds;

  // Convert to kilobits per second (Kbps)
  const bitrateKbps = bitrateBps / 1000;

  return bitrateKbps;
}
